// Diese Datei wird automatisch generiert - nicht manuell bearbeiten!
// Um die Version zu ändern, aktualisiere die "version" in package.json

// Aktuelle Version der Anwendung aus package.json
export const VERSION = '2.5.0';

// Automatisch generierter Build-Timestamp
export const BUILD_TIMESTAMP = new Date().toISOString();

// Generiere eine einzigartige Build-ID (kann auch aus einer Umgebungsvariable gelesen werden)
export const BUILD_ID = import.meta.env.VITE_APP_BUILD_ID || Math.random().toString(36).substring(2, 15);

// Export als Default-Objekt für einfache Verwendung
export default {
  version: VERSION,
  timestamp: BUILD_TIMESTAMP,
  buildId: BUILD_ID,
};
